const ASPECT_PRESETS = [
    { w: 1, h: 1 },
    { w: 5, h: 4 },
    { w: 4, h: 3 },
    { w: 3, h: 2 },
    { w: 7, h: 5 },
    { w: 16, h: 10 },
    { w: 16, h: 9 },
    { w: 2, h: 1 },
    { w: 21, h: 9 },
    { w: 3, h: 1 },
    { w: 4, h: 5 },
    { w: 3, h: 4 },
    { w: 2, h: 3 },
    { w: 9, h: 16 },
    { w: 191, h: 100 }
];

export default ASPECT_PRESETS;
